<template>
  <div>
    <h1 class="pb-2 mb-4">
      We've Got You Covered
    </h1>
    <p>
      Full damage cover specifically designed for Hostel Hoppers, just pay when
      you pick up your vehicle - we cover you for single and mulitple vehicle
      accidents, tyres, windscreen, underbody and rollover damage. For full
      details of cover, please refer to our terms and conditions. <br />
      <span class="small"
        >Please note: damage cover is mandatory for all Hostel Hoppers
        hires.</span
      >
    </p>
    <dl class="row not-featured rounded mb-0">
      <h5 class="card-header col-12 pl-2 mb-2">
        Damage Cover
      </h5>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">Standard Car</dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$35/day</dd>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">Tourer 5</dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$45/day</dd>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">4WD SUV</dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$55/day</dd>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6"></dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6 hh-text">
        ($5 extra for auto)
      </dd>

      <h5 class="card-header col-12 pl-2 mb-2">
        Dropoff in a Different Location
      </h5>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">
        Zone 1 (east coast aus & nz)
      </dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$100</dd>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">
        Zone 2 (west coast & central aus)
      </dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$300</dd>
      <h5 class="card-header col-12 pl-2 mb-2">
        Remote Location Fees
      </h5>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">
        Darwin & Alice Springs
      </dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$50</dd>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">Exmouth</dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$100</dd>
      <dt class="col-8 col-sm-7 col-md-6 col-lg-6">Broome</dt>
      <dd class="col-4 col-sm-5 col-md-6 col-lg-6">$200</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'fees'
}
</script>

<style scoped>
.card-header {
  font-weight: 600 !important;
}
dt {
  font-weight: 100 !important;
}
</style>
